/**
 * This local restriction adapter resolves true if we are running in a browser
 * that supports setting the page as the homepage.
 *
 * Specify restriction as:
 *
 *  canSetHomepage
 */

export const NAME = 'canSetHomepage';

export default function isAllowed(_, { homepageFilters } = {}) {
	return Promise.resolve(shouldSetHomepageShow(homepageFilters));
}

function shouldSetHomepageShow(homepageFilters) {
	let checks = browserChecks();
	if (homepageFilters.hideSpanish && isSpanishPage()) {
		return false;
	}
	return (
		homepageFilters.isFirefox === checks.isFirefox ||
		homepageFilters.isSafari === checks.isSafari ||
		homepageFilters.isIE === checks.isIE ||
		homepageFilters.Edge === checks.isEdge ||
		homepageFilters.isChrome === checks.isChrome
	);
}

/**
 * tests if browser is Firefox/Safari/IE/Edge/Chrome
 * src: stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
 */
function browserChecks() {
	return ({
		isFirefox: typeof InstallTrigger !== 'undefined',
		isSafari: /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === '[object SafariRemoteNotification]'; })(!window.safari || (typeof safari !== 'undefined' && window.safari.pushNotification)),
		isIE: /*@cc_on!@*/false || !!document.documentMode,
		isEdge: /*@cc_on!@*/false || !!document.documentMode && !!window.StyleMedia,
		isChrome: !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)
	});
}

/**
 * checks cookies && href to determine is user is on spanish page
 */
function isSpanishPage() {
	return (document.cookie.includes && document.cookie.includes('es-us')) || (location.href.includes && location.href.includes('lang=es-us'));
}


// WEBPACK FOOTER //
// ../node_modules/@cube/restrictions/src/adapters/sethomepage/index.js